import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

import { auth, db } from "../../../firebase";
import { collection, getDocs } from "firebase/firestore";

import SEO from '../../SEO';
import Popup from "../../mobile/Popup";
import ActTags from '../ActTags';
import Loading from "../../Loading";
import MyPageMenu from './MyPageMenu';
import DeleteSelected from '../DeleteSelected';
import PushPopup from './PushPopup';

import styleClasses from '../css/mobile/MyPage.module.scss';

function PositionsList() {
  const navigate  = useNavigate();

  const [openMenu, setOpenMenu]                     = useState(false);

  const [userID, setUserID]                         = useState('');
  const [positions, setPositions]                   = useState([]);
  const [isLoading, setIsLoading]                   = useState(true);
  const [selectedPositions, setSelectedPositions]   = useState([]); // 선택된 포지션의 id들 관리
  const [selectedPosition, setSelectedPosition]     = useState([]); // 선택된 포지션의 ID: 추가 또는 삭제에 사용

  const [openPopup, setOpenPopup]                   = useState(false);
  const [buttonLoading, setButtonLoading]           = useState(false);
  const [popupTitle, setPopupTitle]                 = useState('');
  const [popupFunction, setPopupFunction]           = useState('');
  const [popupButtonText, setPopupButtonText]       = useState('');

  const [openPushAlbumPopup, setOpenPushAlbumPopup] = useState(false);

  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

  // 🔹 포지션 & 스킬 가져오기
  const fetchPositions = useCallback(async () => {
    if (userID === '') return;

    try {
      // /users_data/[UID]/positions 컬렉션 가져오기
      const positionsRef = collection(db, "users_data", userID, "positions");
      const positionsSnapshot = await getDocs(positionsRef);

      // 각 포지션 문서별로 act 필드와 skills 하위컬렉션 조회
      const positionsData = await Promise.all(
        positionsSnapshot.docs.map(async (posDoc) => {
          const posId = posDoc.id; // 예: "creator", "player", "engineer"
          const posData = posDoc.data();
          const act = posData.act || {}; // act 필드가 없으면 빈 객체
          const skillsRef = collection(db, "users_data", userID, "positions", posId, "skills");
          const skillsSnapshot = await getDocs(skillsRef);
          const skills = skillsSnapshot.docs.map((skillDoc) => ({
            id: skillDoc.id,
            ...skillDoc.data(),
          }));
          // 스킬들을 이름순으로 정렬
          skills.sort((a, b) => a.name.localeCompare(b.name));
          return { id: posId, act, skills };
        })
      );
      
      // 포지션을 미리 정해진 순서로 정렬 (예: creator, player, engineer)
      const order = ["creator", "player", "engineer"];
      positionsData.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

      setPositions(positionsData);
      setIsLoading(false);
    } catch (err) {
      console.error("포지션 데이터를 불러오는 중 오류 발생:", err);
      setIsLoading(false);

      setOpenPopup(true);
      setPopupTitle(`포지션 데이터를 불러오는 중 오류가 발생했습니다.`);
      setPopupButtonText('');
      setPopupFunction('');
    }
  }, [userID]);
  
  // 🔹 페이지 로드 - 로그인 확인 후 함수 호출
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate('/login', { state: { from: window.location.pathname } });
      } else {
        setUserID(user.uid);
        fetchPositions();
      }
    });
    return () => unsubscribe();
  }, [navigate, fetchPositions]);

  // 🔹 포지션 선택 토글 함수
  const handleCheckboxChange = (positionId) => {
    setSelectedPositions((prevSelected) => {
      if (prevSelected.includes(positionId)) {
        return prevSelected.filter((id) => id !== positionId);
      } else {
        return [...prevSelected, positionId];
      }
    });
  };

  // 🔹 뮤지카드 포지션 적용 팝업
  useEffect(() => {
    if (selectedPosition.length) {
      setOpenPushAlbumPopup(true);
    }
  }, [selectedPosition]);

  return (
    <>
      <SEO title='포지션 & 스킬 목록' />
      <div className={styleClasses.myPageMobile}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.title}>
            <h1>Position & Skill</h1>
            <button className={ styleClasses.menuIcon }>
              <div className="commonIcon mobile">
                <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
              </div>
            </button>
            <div className={`commonIcon mobile toolTip ${ styleClasses.titleToolTip }`}>
              <i className="questionBlack w20"></i>
              <div className="toolTipText bottom">
                <p>나의 포지션과 스킬 (솔로 뮤지카드용) <br />나의 능력을 제일 잘 보여줄 링크와 함께 <br />내 스킬을 뽐내고 포지션을 어필해보세요!</p>
              </div>
            </div>
          </div>
          <div className={styleClasses.editContent}>
            <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
              <MyPageMenu currentPage='position-skill' />
            </div>
            <div className={styleClasses.rightContent}>
              <div className={styleClasses.content}>
                <div className={styleClasses.myArchive}>
                  <div className={styleClasses.topButtons}>
                    <div className={`commonIcon toolTip mobile ${ styleClasses.topButtonToolTip }`}>
                      <i className="questionBlack w20"></i>
                      <div className="toolTipText bottom">
                        <p>나의 포지션 카드를 자유롭게 추가, 수정, 삭제하세요. <br />그리고 원하는 카드만 골라서 뮤지카드에 적용해보세요!</p>
                      </div>
                    </div>
                    {/* DeleteSelected 컴포넌트에 필수 prop들을 전달 */}
                    <DeleteSelected
                      selectedIDs={ selectedPositions }
                      documents={ positions }
                      collectionPath={`users_data/${ userID }/positions`}
                      userID={ userID }
                      itemName="포지션"
                      subcollections={["skills"]}
                      onDeleteSuccess={() => setSelectedPositions([])}
                      fetchData={fetchPositions}
                      setOpenPopup={ setOpenPopup }
                      setButtonLoading={ setButtonLoading }
                      setPopupTitle={ setPopupTitle }
                      setPopupFunction={ setPopupFunction }
                      setPopupButtonText={ setPopupButtonText }
                    />
                    <div className="commonButton fullwidth">
                      <Link to={`/my-page/position-skill/new`} className="black">추가</Link>
                    </div>
                  </div>
                  <div className={ styleClasses.positionSkillList }>
                    {
                      isLoading
                      ?
                      <Loading />
                      :
                      positions.map((position) => (
                        <div key={ position.id } className={styleClasses.eachAlbumCard}>
                          <div className={ styleClasses.positionCard }>
                            <div className="commonForm">
                              <div className="formRow">
                                <div className="fieldBox checkBox">
                                  <div className="eachBox">
                                    <input
                                        type="checkbox"
                                        id={`position_${position.id}`}
                                        checked={selectedPositions.includes(position.id)}
                                        onChange={() => handleCheckboxChange(position.id)}
                                    />
                                    <label htmlFor={`position_${position.id}`}>{ position.id.toUpperCase() }</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={ styleClasses.skillCard }>
                              {position.skills.length > 0 ? (
                                position.skills.map((skill) => (
                                <div key={skill.id} className={ styleClasses.eachCard } style={{ position: "relative" }}>
                                    <Link to={`/my-page/position-skill/${position.id}`} className={styleClasses.linkBox}>
                                    {
                                      skill.icon
                                      ?
                                      (
                                        <img src={ skill.icon } alt={ skill.name } />
                                      )
                                      :
                                      (
                                        <div className={ styleClasses.placeholder }>이미지를 지정해주세요.</div>
                                      )
                                    }
                                    <div className={styleClasses.skillBox}>
                                      <p className={ styleClasses.skill }>{ skill.name ? skill.name : "스킬 없음" }</p>
                                      <p className={ styleClasses.level }>{ skill.level ? skill.level : "" }</p>
                                    </div>
                                    </Link>
                                </div>
                                ))
                              ) : (
                                  <p className={styleClasses.noMusicard}>스킬 데이터가 없습니다.</p>
                              )}
                            </div>
                            {/* ActTags 컴포넌트 추가 */}
                            <ActTags
                              mobile={ true }
                              act={ position.act }
                              userUid={ userID }
                              attribute="positions"
                              albumID={ position.id }
                              fetchData={ fetchPositions }
                              setSelectedItem={ setSelectedPosition }
                              setOpenPopup={ setOpenPopup }
                              setButtonLoading={ setButtonLoading }
                              setPopupTitle={ setPopupTitle }
                              setPopupFunction={ setPopupFunction }
                              setPopupButtonText={ setPopupButtonText }
                            />
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PushPopup
        open={ openPushAlbumPopup }
        setOpenPopup={ setOpenPushAlbumPopup }
        attribute="positions"
        selectedItem={ selectedPosition }       // 단일 선택
        selectedItems={ [] }                    // 다중 선택
        setSelectedItem={ setSelectedPosition } // 단일 선택 초기화
        clearSelectedItems={ () => void(0) }    // 다중 선택 초기화 함수 (필요하면)
        categoryOptions={[]} // 필요한 카테고리 옵션이 있으면 설정
        defaultCategory="positions" // 또는 기본 카테고리 값
        fetchData={ fetchPositions }
        setOpenAlertPopup={ setOpenPopup }
        setPopupTitle={ setPopupTitle }
        setPopupButtonText={ setPopupButtonText }
        setPopupFunction={ setPopupFunction }
      />
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } buttonLoading={ buttonLoading } />
    </>
  );
}

export default PositionsList;